module.exports = __webpack_public_path__ + "img/end-address-icon.3766e788.png";